/* TUDD – Build Your Own Bundle landing page. Loaded only by sections/tudd-byob.liquid */
(() => {
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents, format) {
    const amount = (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
    return format ? format.replace(/\{\{\s*\w+\s*\}\}/, amount) : `₹${amount}`;
  }

  function init(el) {
    if (el.dataset.tuddReady) return;
    el.dataset.tuddReady = 'true';

    const t1 = { qty: +el.dataset.t1Qty || 2, pct: +el.dataset.t1Pct || 0 };
    const t2 = { qty: +el.dataset.t2Qty || 3, pct: +el.dataset.t2Pct || 0 };
    const fmt = el.dataset.moneyFormat;
    const selected = new Map(); // productId -> { variantId, price, image, title }

    const $ = (sel) => el.querySelector(sel);
    const slots = $('[data-tudd-byob-slots]');
    const msg = $('[data-tudd-byob-msg]');
    const progress = $('[data-tudd-byob-progress]');
    const wasEl = $('[data-tudd-byob-was]');
    const nowEl = $('[data-tudd-byob-now]');
    const saveEl = $('[data-tudd-byob-save]');
    const addBtn = $('[data-tudd-byob-add]');
    const addLabel = addBtn.textContent.trim();

    const readVariant = (card) => {
      const input = card.querySelector('[data-tudd-byob-variant]');
      const opt = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
      return {
        variantId: Number(input.value),
        price: parseInt(opt.dataset.price, 10) || 0,
        image: opt.dataset.image,
        title: opt.dataset.title,
      };
    };

    const tierFor = (n) => (n >= t2.qty ? t2 : n >= t1.qty ? t1 : null);

    function render() {
      const items = [...selected.entries()];
      const n = items.length;

      // Slots: always show at least tier-2 count, filled with picks
      const slotCount = Math.max(t2.qty, Math.min(n, 4));
      slots.innerHTML = '';
      for (let i = 0; i < slotCount; i++) {
        const li = document.createElement('li');
        li.className = 'tudd-byob__slot';
        const item = items[i];
        if (i === 3 && n > 4) {
          li.classList.add('is-filled');
          li.innerHTML = `<span class="tudd-byob__slot-more">+${n - 3}</span>`;
        } else if (item) {
          const [pid, d] = item;
          li.classList.add('is-filled');
          li.innerHTML = `<img src="${d.image}" alt="" width="46" height="46"><button type="button" class="tudd-byob__slot-x" data-remove="${pid}" aria-label="Remove ${d.title.replace(/"/g, '&quot;')}">×</button>`;
        } else {
          li.textContent = '+';
        }
        slots.appendChild(li);
      }

      // Message
      if (n === 0) {
        msg.innerHTML = `Pick any <strong>${t1.qty}</strong> to unlock <strong>${t1.pct}% OFF</strong>`;
      } else if (n < t1.qty) {
        msg.innerHTML = `Add <strong>${t1.qty - n} more</strong> to unlock <strong>${t1.pct}% OFF</strong>`;
      } else if (n < t2.qty) {
        msg.innerHTML = `<strong>${t1.pct}% OFF unlocked!</strong> Add ${t2.qty - n} more for <strong>${t2.pct}% OFF</strong>`;
      } else {
        msg.innerHTML = `<strong>${t2.pct}% OFF unlocked!</strong> Best price on your bundle`;
      }

      progress.style.width = `${Math.min(n / t2.qty, 1) * 100}%`;

      // Totals
      const total = items.reduce((sum, [, d]) => sum + d.price, 0);
      const tier = tierFor(n);
      const pct = tier ? tier.pct : 0;
      const now = Math.round((total * (100 - pct)) / 100);
      nowEl.textContent = money(now, fmt);
      wasEl.hidden = pct === 0;
      wasEl.textContent = money(total, fmt);
      saveEl.hidden = pct === 0;
      saveEl.textContent = `Save ${money(total - now, fmt)}`;

      addBtn.disabled = n < t1.qty;
      addBtn.textContent = n < t1.qty ? `Pick ${t1.qty - n} more` : addLabel;
    }

    function setSelected(card, on) {
      const pid = card.dataset.productId;
      card.classList.toggle('is-selected', on);
      card.querySelector('[data-tudd-byob-toggle]').setAttribute('aria-pressed', String(on));
      if (on) selected.set(pid, readVariant(card));
      else selected.delete(pid);
      render();
    }

    el.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-tudd-byob-toggle]');
      if (toggle) {
        const card = toggle.closest('[data-tudd-byob-card]');
        setSelected(card, !card.classList.contains('is-selected'));
        return;
      }
      const remove = e.target.closest('[data-remove]');
      if (remove) {
        const card = el.querySelector(`[data-tudd-byob-card][data-product-id="${remove.dataset.remove}"]`);
        if (card) setSelected(card, false);
      }
    });

    el.addEventListener('change', (e) => {
      if (!e.target.matches('[data-tudd-byob-variant]')) return;
      const card = e.target.closest('[data-tudd-byob-card]');
      const d = readVariant(card);
      const priceEl = card.querySelector('[data-tudd-byob-price]');
      if (priceEl) priceEl.textContent = money(d.price, fmt);
      if (selected.has(card.dataset.productId)) {
        selected.set(card.dataset.productId, d);
        render();
      }
    });

    addBtn.addEventListener('click', async () => {
      if (selected.size < t1.qty) return;
      addBtn.classList.add('is-loading');
      el.querySelector('.tudd-byob__error')?.remove();
      try {
        const items = [...selected.values()].map((d) => ({ id: d.variantId, quantity: 1 }));
        const res = await fetch(`${root()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');

        const after = el.dataset.afterAdd;
        if (after === 'checkout') return (window.location.href = `${root()}checkout`);
        if (after === 'cart') return (window.location.href = `${root()}cart`);

        const cart = await fetch(`${root()}cart.js`).then((r) => r.json());
        document.dispatchEvent(
          Object.assign(new Event('cart:update', { bubbles: true }), {
            detail: { resource: cart, sourceId: 'tudd-byob', data: { source: 'tudd-byob', itemCount: cart.item_count } },
          })
        );
        addBtn.classList.remove('is-loading');
      } catch (err) {
        addBtn.classList.remove('is-loading');
        const p = document.createElement('p');
        p.className = 'tudd-byob__error';
        p.setAttribute('role', 'alert');
        p.textContent = err.message;
        addBtn.closest('.tudd-byob__bar-inner').appendChild(p);
      }
    });

    render();
  }

  const boot = () => document.querySelectorAll('[data-tudd-byob]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
